import { LIMITE_CORTESIA_IA } from './types';

/** Mes calendario de Colombia, YYYY-MM. */
export function periodoMesActual(ahora: Date = new Date()): string {
  const partes = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Bogota',
    year: 'numeric',
    month: '2-digit',
  }).format(ahora);
  return partes.slice(0, 7);
}

/** El contador guardado solo cuenta si pertenece al mes en curso. */
export function usadasDelMes(usadas: number, periodo?: string | null, ahora: Date = new Date()): number {
  const u = Number.isFinite(usadas) ? usadas : 0;
  if (periodo && periodo !== periodoMesActual(ahora)) return 0;
  return u;
}

export function restanteCortesia(
  usadas: number,
  limite: number = LIMITE_CORTESIA_IA
): number {
  const u = Number.isFinite(usadas) ? usadas : 0;
  const l = Number.isFinite(limite) ? limite : LIMITE_CORTESIA_IA;
  return Math.max(0, l - u);
}

export function puedeUsarCortesia(
  usadas: number,
  limite: number = LIMITE_CORTESIA_IA
): boolean {
  return restanteCortesia(usadas, limite) > 0;
}

export function etiquetaCuotaIa(usadas: number, limite: number = LIMITE_CORTESIA_IA): string {
  const left = restanteCortesia(usadas, limite);
  if (left <= 0) {
    return `Cupo del mes agotado (${limite}/${limite}). Usa tu clave de OpenAI o ChatGPT.`;
  }
  return `${left} de ${limite} imágenes este mes`;
}
